import type {CsmType} from 'nutshell-graphql-types';

export const getImageFromCsmType = (csmType: CsmType) => {
    switch (csmType) {
        case 'RACHEL':
            return '/include/images/portraits/rachel.png';
        case 'DEVIN':
            return '/include/images/portraits/devin.png';
    }
};
